export default __webpack_public_path__ + "static/media/fireball.32c0a827.webp";